<template>
    <div class="section-listGame GamesBlockWithBigLeftItem" :class="additionalRowClasses">
        <div class="section-listGame__content">
            <div class="listGame__list firstBox">
                <game-item v-for="(item, index) in loadedGames" :key="index"
                           :item="item" :image-property-name="gameImagePropertyName(index)"
                           class="listGame__list-item"/>
            </div>
        </div>

        <div class="section-listGame__footer" v-show="showLoadMoreButton">
            <v-btn :loading="loading" class="btn-load" @click="showMoreGames" v-show="hasMoreGames">
                {{ $t('front.game.button.load_more') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import categoryGame from "../../mixins/categoryGame";
import apiData from "../../mixins/apiData";

export default {
    name: "GamesBlockWithBigLeftItem",

    props: {
        items: {},
        showLoadMoreButton: {},
        loadMoreDesktopRowsCount: {},
        loadMoreMobileRowsCount: {},
        totalItemsCount: {},
        recommendationId: {},
        categoryId: {},
        virtualCategoryInterfaceId: {},
        additionalGameRowsCount: {
            default: 0,
        },
    },

    mixins: [apiData, categoryGame],

    data: function () {
        return {
            currentAdditionalRowsCount: this.additionalGameRowsCount,
            totalGamesCount: this.totalItemsCount,
            vendorRecommendationId: this.recommendationId,
        };
    },

    computed: {
        additionalRowClasses() {
            let classes = [`additional_game_rows_count_${this.additionalGameRowsCount}`];
            this.moreGamesMode && classes.push('more-games-mode');

            return classes;
        },

        loadedGames(){
            return this.items.concat(this.loadMoreGames);
        },

        startGamesCount(){
            // for server side
            if (!this.screenWidth) {
                return  this.isDeviceMobile ? 4 : 8;
            }

            if (this.screenWidth > 1024) {
                return 7;
            } else if (this.screenWidth > 767) {
                return 8;
            }else if (this.screenWidth > 600) {
                return 6;
            } else {
                return 4;
            }
        },

        additionalRowGamesCount(){
            // for server side
            if (!this.screenWidth) {
                return  this.isDeviceMobile ? 2 : 5;
            }

            if (this.screenWidth > 1024) {
                return 5;
            } else if (this.screenWidth > 767) {
                return 4;
            }else if (this.screenWidth > 600) {
                return 3;
            } else {
                return 2;
            }
        },

        loadMoreRowsCount(){
            return (this.isDeviceMobile ? this.loadMoreMobileRowsCount : this.loadMoreDesktopRowsCount) || 2;
        },

        loadMoreGamesCount(){
            return this.startGamesCount + (this.currentAdditionalRowsCount + this.loadMoreRowsCount) * this.additionalRowGamesCount - this.loadedGames.length;
        },
    },

    methods: {
        showMoreGames() {
            this.fetchLoadMoreCategoryGames().then(() => this.currentAdditionalRowsCount += this.loadMoreRowsCount);
        },

        gameImagePropertyName(index) {
            return index === 0 ? 'bigCoverImage' : 'coverImage';
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/games/GamesBlockWithBigLeftItem"
</style>
